import { memo, SVGAttributes } from "react";

const ArrowCircled = memo((props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="13"
      height="17"
      viewBox="0 0 13 17"
      fill="none"
      aria-label="map-point"
      role="icon"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`svg-map-point ${props.className || ""}`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 6.04233C1.5 3.25393 3.74228 1 6.50027 1C9.25825 1 11.5005 3.25393 11.5005 6.04233C11.5005 6.69675 11.2306 7.59019 10.7677 8.60436C10.3111 9.60454 9.69199 10.6686 9.04961 11.6463C8.40762 12.6234 7.7496 13.5033 7.22063 14.1347C6.95516 14.4515 6.72887 14.6978 6.55792 14.8607C6.53733 14.8803 6.51811 14.8981 6.50026 14.9143C6.48241 14.8981 6.4632 14.8803 6.44262 14.8607C6.27166 14.6978 6.04537 14.4515 5.7799 14.1347C5.25093 13.5033 4.59291 12.6234 3.95093 11.6463C3.30854 10.6686 2.68945 9.60454 2.23286 8.60436C1.76988 7.59019 1.5 6.69675 1.5 6.04233ZM6.50027 0C3.18283 0 0.5 2.70884 0.5 6.04233C0.5 6.91838 0.845291 7.97284 1.32316 9.01964C1.80742 10.0804 2.45485 11.1904 3.11518 12.1954C3.7759 13.201 4.45677 14.1125 5.01337 14.7769C5.29068 15.1079 5.54385 15.3856 5.75283 15.5847C5.85626 15.6832 5.9591 15.7724 6.05582 15.8403C6.10408 15.8741 6.1608 15.9098 6.22303 15.9387C6.27827 15.9644 6.37745 16.0037 6.50027 16.0037C6.62308 16.0037 6.72226 15.9644 6.7775 15.9387C6.83973 15.9098 6.89645 15.8741 6.94471 15.8403C7.04143 15.7724 7.14427 15.6832 7.2477 15.5847C7.45669 15.3856 7.70985 15.1079 7.98716 14.7769C8.54376 14.1125 9.22463 13.201 9.88535 12.1954C10.5457 11.1904 11.1931 10.0804 11.6774 9.01964C12.1552 7.97284 12.5005 6.91838 12.5005 6.04233C12.5005 2.70884 9.81771 0 6.50027 0ZM6.50042 8.00189C7.51299 8.00189 8.33384 7.16222 8.33384 6.12643C8.33384 5.09065 7.51299 4.25098 6.50042 4.25098C5.48785 4.25098 4.667 5.09065 4.667 6.12643C4.667 7.16222 5.48785 8.00189 6.50042 8.00189Z"
        fill="#FF0000"
      />
    </svg>
  );
});

ArrowCircled.displayName = "ArrowCircled";
export default ArrowCircled;
